import React, {FC} from 'react';
import {useQuery} from '@tanstack/react-query';
import {USDollar} from '../utils/format';
import themeColor from '../utils/themeColors';
import {Text, Center, Heading, Progress} from 'components/ui/chakra';
import AdminAnalyticsController from 'puddleglum/api/admin/AdminAnalyticsController';
import EmployerAnalyticsController from 'puddleglum/api/employer/EmployerAnalyticsController';
import ProviderAnalyticsController from 'puddleglum/api/providers/ProviderAnalyticsController';

interface PaymentAnalyticCardProps {
	type: 'all' | 'recent' | 'pending' | 'pending-invoices';
	scope: 'organization' | 'employer' | 'all';
}

const PaymentAnalyticCard: FC<PaymentAnalyticCardProps> = ({type, scope}) => {
	const {data: payment} = useQuery(['provider-payments', type], async () => {
		if (scope === 'all') {
			const reply = await AdminAnalyticsController.getPayments(type);
			return reply.data;
		}

		if (scope === 'organization') {
			const data = await ProviderAnalyticsController.getPayments(type);
			return data.data;
		}

		const data = await EmployerAnalyticsController.getInvoicesByType(type);
		return data.data;
	});

	if (!payment) return <Progress size='sm' isIndeterminate />;

	return (
		<>
			<Center mt={4}>
				<Heading color={`${themeColor()}.600`} size='lg'>
					{USDollar.format(payment.total)}
				</Heading>
			</Center>
			<Center mb={4}>
				<Text color='subtleText'>{payment.count} total</Text>
			</Center>
		</>
	);
};

export default PaymentAnalyticCard;
